<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.583 6.64631C21.354 5.64231 20.676 4.85031 19.814 4.57831C18.255 4.09131 12 4.09131 12 4.09131C12 4.09131 5.748 4.09131 4.186 4.57831C3.327 4.84631 2.649 5.63831 2.417 6.64631C2 8.46831 2 12.2733 2 12.2733C2 12.2733 2 16.0783 2.417 17.9003C2.646 18.9043 3.324 19.6963 4.186 19.9683C5.748 20.4553 12 20.4553 12 20.4553C12 20.4553 18.255 20.4553 19.814 19.9683C20.673 19.7003 21.351 18.9083 21.583 17.9003C22 16.0783 22 12.2733 22 12.2733C22 12.2733 22 8.46831 21.583 6.64631Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0039 15.2734L15.1999 12.2734L10.0039 9.27344V15.2734Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
